export default "__VITE_ASSET__CcY4ycWz__"